import reactDom from './morph/react-dom/restricted-names.js'
import reactNative from './morph/react-native/restricted-names.js'

export default {
  'react-dom': reactDom,
  'react-native': reactNative,
  e2e: [],
}
